import { SelectedMarkerI } from './context'
import { MapSelectPoint } from './interface'

/* eslint-disable @typescript-eslint/explicit-function-return-type */

enum ACTION_TYPES {
  TOGGLE_MAP_SLIDE_VISIBILITY = 'TOGGLE_MAP_SLIDE_VISIBILITY',
  TOGGLE_MAP_SIDEBAR_VISIBILITY = 'TOGGLE_MAP_SIDEBAR_VISIBILITY',
  TOGGLE_MAP_ZOOM_ALERT_MESSAGE = 'TOGGLE_MAP_ZOOM_ALERT_MESSAGE',
  SET_ADDRESS_LIST = 'SET_ADDRESS_LIST',
  SET_SELECTED_MARKER = 'SET_SELECTED_MARKER',
}

type MapSelectActionType =
  | ACTION_TYPES.TOGGLE_MAP_SLIDE_VISIBILITY
  | ACTION_TYPES.TOGGLE_MAP_SIDEBAR_VISIBILITY
  | ACTION_TYPES.TOGGLE_MAP_ZOOM_ALERT_MESSAGE
  | ACTION_TYPES.SET_ADDRESS_LIST
  | ACTION_TYPES.SET_SELECTED_MARKER

type MapSelectActionsReturn =
  | ReturnType<typeof toggleMapSlideVisibility>
  | ReturnType<typeof openMapSidebar>
  | ReturnType<typeof closeMapSidebar>
  | ReturnType<typeof openMapZoomAlertMessage>
  | ReturnType<typeof closeMapZoomAlertMessage>
  | ReturnType<typeof setAddressList>
  | ReturnType<typeof setSelectedMarker>

interface MapSelectActions<T extends MapSelectActionType, P> {
  type: T
  payload: P
}

function createMapSelectAction<T extends MapSelectActionType, P extends Record<string, unknown>>(
  type: T,
  payload: P
): MapSelectActions<T, P> {
  return { type, payload }
}

const toggleMapSlideVisibility = () =>
  createMapSelectAction(ACTION_TYPES.TOGGLE_MAP_SLIDE_VISIBILITY, {})

const openMapSidebar = () =>
  createMapSelectAction(ACTION_TYPES.TOGGLE_MAP_SIDEBAR_VISIBILITY, { isSidebarOpen: true })

const closeMapSidebar = () =>
  createMapSelectAction(ACTION_TYPES.TOGGLE_MAP_SIDEBAR_VISIBILITY, { isSidebarOpen: false })

const openMapZoomAlertMessage = () =>
  createMapSelectAction(ACTION_TYPES.TOGGLE_MAP_ZOOM_ALERT_MESSAGE, {
    isZoomAlertMessageOpen: true,
  })

const closeMapZoomAlertMessage = () =>
  createMapSelectAction(ACTION_TYPES.TOGGLE_MAP_ZOOM_ALERT_MESSAGE, {
    isZoomAlertMessageOpen: false,
  })

const setAddressList = (addressList: MapSelectPoint[]) =>
  createMapSelectAction(ACTION_TYPES.SET_ADDRESS_LIST, { addressList })

const setSelectedMarker = (selectedMarker: SelectedMarkerI) =>
  createMapSelectAction(ACTION_TYPES.SET_SELECTED_MARKER, { selectedMarker })

export {
  ACTION_TYPES,
  MapSelectActions,
  MapSelectActionType,
  MapSelectActionsReturn,
  toggleMapSlideVisibility,
  openMapSidebar,
  closeMapSidebar,
  openMapZoomAlertMessage,
  closeMapZoomAlertMessage,
  setAddressList,
  setSelectedMarker,
}
